/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const itemSchema = z.object({
  deadlineDateTime: z.iso.datetime().nullish(),
  description: z.string().nullish(),
  doneDateTime: z.iso.datetime().nullish(),
  earliestStartDateTime: z.iso.datetime().nullish(),
  estimateHighEffortSeconds: z.int().nullish(),
  estimateLowEffortSeconds: z.int().nullish(),
  estimationId: z.int().nullish(),
  estimationSourceUpdatedAt: z.iso.datetime().nullish(),
  externalCreatedAt: z.iso.datetime().nullish(),
  externalKey: z.string().nullish(),
  externalLink: z.string().nullish(),
  forecastedFinishDateTime: z.iso.datetime().nullish(),
  forecastedStartDateTime: z.iso.datetime().nullish(),
  id: z.int(),
  itemCreatedAt: z.iso.datetime(),
  itemStatusId: z.int(),
  itemTypeId: z.int(),
  loopId: z.int().nullish(),
  name: z.string().nullish(),
  parentId: z.int().nullish(),
  parentManagedByIntegration: z.boolean(),
  plannedFinishDateTime: z.iso.datetime().nullish(),
  plannedStartDateTime: z.iso.datetime().nullish(),
  priority: z.string().nullish(),
  schedulingType: z.enum(['ACTUALS_ONLY', 'PLANNED_AND_ACTUALS']).nullish(),
  sourceUpdatedAt: z.iso.datetime().nullish(),
  teamId: z.int().nullish(),
  timeSpentSeconds: z.int().nullish(),
});
